import { Box, FormControl, FormLabel, Text } from "@chakra-ui/react";

import { useColor } from "@/styles/useColor";

type MemoPreviewFieldProps = {
  memo: string;
};

export const MemoPreviewField = ({ memo }: MemoPreviewFieldProps) => {
  const color = useColor();

  return (
    <FormControl>
      <FormLabel width="full">Memo</FormLabel>
      <Box padding="12px 16px" background={color("100")} borderRadius="4px" data-testid="memo-tile">
        <Text color={color("700")} fontSize="14px">
          {memo}
        </Text>
      </Box>
    </FormControl>
  );
};
